import React from 'react';

import { IActiveCampaignFragment } from 'generated/sanity-graphql';

import { StyledPicture, StyledText, Wrapper } from './campaign-headline.styled';

const CampaignHeadline = React.memo(({ campaign }: { campaign?: IActiveCampaignFragment }) => {
  return (
    <Wrapper>
      {campaign?.campaignImage?.locale ? (
        <StyledPicture
          image={campaign.campaignImage.locale}
          alt={campaign?.campaignImageAltText?.locale ?? ''}
        />
      ) : null}
      {campaign?.campaignText?.localeRaw ? (
        <StyledText content={campaign?.campaignText?.localeRaw} />
      ) : null}
    </Wrapper>
  );
});

export default CampaignHeadline;
